import { render, staticRenderFns } from "./PublicAthleteSideNav.vue?vue&type=template&id=65daca79&scoped=true&"
import script from "./PublicAthleteSideNav.vue?vue&type=script&lang=ts&"
export * from "./PublicAthleteSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./PublicAthleteSideNav.vue?vue&type=style&index=0&id=65daca79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65daca79",
  null
  
)

export default component.exports